import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerShellServiceWorker } from './serviceWorkerRegistration';

// M004-F0651 — the running build's id, visible to support and to the update-path
// e2e (tests/shell-update-path.spec.ts). CI sets REACT_APP_BUILD_ID per commit.
document.documentElement.setAttribute('data-build-id', process.env.REACT_APP_BUILD_ID || 'unset');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerShellServiceWorker();
